import { Component, Input, OnInit } from '@angular/core';
import { ApplicationStateStoreProxyService, ProposalMetric } from '@ddt-web/shared-stores';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { distinctUntilKeyChanged } from 'rxjs/operators';

@UntilDestroy()
@Component({
	// eslint-disable-next-line @angular-eslint/component-selector
	selector: 'proposal-metrics',
	templateUrl: './proposal-metrics.component.html',
	styleUrls: ['./proposal-metrics.component.scss']
})
export class ProposalMetricsComponent implements OnInit {

	/**
	 * This is required only to drive the visibility of proposal metrics based on report modularity (not required in web)
	*/
	@Input() public pdfCustomisationConfig?: any;

	public sectionsToDisable: any = [];
	public metrics: ProposalMetric[] = [];

	constructor(
		private applicationStateStoreProxyService: ApplicationStateStoreProxyService
	) { }

	public ngOnInit(): void {
		this.sectionsToDisable = (this.pdfCustomisationConfig?.sections ?? []).filter(section => !section.checked).map(section => section.nameKey);

		this.applicationStateStoreProxyService.getProposalState().pipe(
			untilDestroyed(this),
			distinctUntilKeyChanged('metrics', (previousMetrics, currentMetrics) => {
				return JSON.stringify(previousMetrics) === JSON.stringify(currentMetrics);
			})
		).subscribe(state => {
			this.metrics = state.metrics ?? [];
		});
	}

}
